export const METADATA_CONTEXT_FLOW = {
  TEST_AUTHORING: 'testAuthoring',
  TEST_BULK_METADATA_GENERATION: 'testBulkMetadataGeneration',
  ITEM_AUTHORING: 'itemAuthoring',
}
